export default class BaseLevelListObject {
  constructor() {
    this.idxLeSugangGroupLang = 0;
    this.idxLeSugangGroupLevel = 0;
    this.levelName = "";
    this.sugangGroupClassList = new Array();
    this.staffIdx = 0;
  }
}
